import { getAuthData } from "../auth/session.js";
// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
export async function arenaRequest(u, o = {}, m) {
  const r = getAuthData();
  if (!r) throw new Error("Откройте арену внутри Telegram");
  const g = new AbortController(),
    j = () => g.abort();
  m?.addEventListener("abort", j, {
    once: !0
  }), m?.aborted && g.abort();
  const B = window.setTimeout(j, 2e4);
  try {
    const U = await fetch(`/api/arena/${u}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          ...o,
          initData: r
        }),
        signal: g.signal
      }),
      N = await U.json().catch(() => null);
    if (!U.ok || !N) throw new Error(N?.error || "Не удалось получить данные арены. Попробуйте ещё раз.");
    return N;
  } catch (U) {
    throw g.signal.aborted && !m?.aborted ? new Error("Сервер отвечает слишком долго. Обновите арену и проверьте колоду.") : U;
  } finally {
    window.clearTimeout(B), m?.removeEventListener("abort", j);
  }
}
